"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixHttpClient = void 0;
const axios_1 = require("axios");
const utils_1 = require("../utils/utils");
const CLIENT_API_R0 = '/_matrix/client/r0';
class MatrixHttpClient {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    async get(endpoint, params, options) {
        return this.send('GET', endpoint, options, params);
    }
    async post(endpoint, body, options, params) {
        return this.send('POST', endpoint, options, params, body);
    }
    async put(endpoint, body, options, params) {
        return this.send('PUT', endpoint, options, params, body);
    }
    async send(method, endpoint, config, requestParams, data) {
        const headers = config ? this.getHeaders(config) : undefined;
        const params = requestParams ? this.getParams(requestParams) : undefined;
        const response = await axios_1.default.request({
            method,
            url: endpoint,
            baseURL: this.apiUrl(CLIENT_API_R0),
            headers,
            data,
            params
        });
        return response.data;
    }
    getHeaders(options) {
        const headers = {};
        const entries = [];
        if (options.accessToken) {
            entries.push(['Authorization', `Bearer ${options.accessToken}`]);
        }
        if (entries.length === 0) {
            return undefined;
        }
        for (const [key, value] of entries) {
            headers[key] = value;
        }
        return headers;
    }
    getParams(_params) {
        if (!_params) {
            return undefined;
        }
        const params = Object.assign(_params, {});
        utils_1.keys(params).forEach((key) => params[key] === undefined && delete params[key]);
        return params;
    }
    apiUrl(...parts) {
        const apiBase = this.baseUrl.endsWith('/')
            ? this.baseUrl.substr(0, this.baseUrl.length - 1)
            : this.baseUrl;
        const apiParts = parts.map((path) => (path.startsWith('/') ? path.substr(1) : path));
        return [apiBase, ...apiParts].join('/');
    }
}
exports.MatrixHttpClient = MatrixHttpClient;
//# sourceMappingURL=MatrixHttpClient.js.map